import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Consumes the one-shot `?mode=edit` deep link (the missing-details popup after login sends the
 * user to /account-details/account?mode=edit) by stripping the param once the page has opened in
 * edit mode.
 *
 * Load-bearing: the account pages remount their Inner on every refetch (keyed on dataUpdatedAt)
 * and Cancel discards edits BY refetching. With the param still in the address bar, that remount
 * re-reads it and drops the user straight back into edit mode — Cancel looks like it does nothing.
 * Edit mode lives in the Inner's own state from mount onwards, so removing the param doesn't end
 * the session the user is already in.
 */
export function useConsumeEditModeParam(active: boolean) {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (!active) {
			return;
		}
		const params = new URLSearchParams(location.search);
		if (params.get('mode') !== 'edit') {
			return;
		}
		params.delete('mode');
		navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
	}, [active, location.pathname, location.search, navigate]);
}
